export default "__VITE_ASSET__ne$CUQjo__"